import React from 'react';
import { Link } from 'react-router-dom';
import './Dropdown.css'

function DropdownAbout(props) {

  return (
    <div className='dropdown-menu'>
      <ul>
        <li className='dropdown-li'><Link to='/about/leadership' onClick={props} className='dropdown-link'>Leadership</Link></li>
        <li className='dropdown-li'><Link to='/about/history' onClick={props} className='dropdown-link'>History</Link></li>
        <li className='dropdown-li'><Link to='/about/gospel' onClick={props} className='dropdown-link'>Gospel</Link></li>
        <li className='dropdown-li'><Link to='/about/statement-of-faith' onClick={props} className='dropdown-link'>Statement of Faith</Link></li>     
      </ul>
    </div>
  )
}
export default DropdownAbout
